import React, { useEffect, useState } from 'react'
import "./Loading.css"
function Loading({loading}) {
    let [a,setA] =useState(0)

  return (
    <div className='absolute-loading'>
        <div className='loading-screen'>
            <div className='loading-percent'>
                
            </div>
            <div className="loading-overlay"></div>
        </div>
    </div>
  )
}

export default Loading